<template>
  <b-form @submit="onSubmit" @keydown.enter.prevent>
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <small class="d-block">#{{ concedente.id }}</small>
            <b>{{ concedente.nome }}</b>
          </div>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('concedentes_list')"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>

        <b-tab title="Endereço">
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.endereco"
            />
            Endereço
          </template>
          <Endereco v-model="concedente" ref="endereco" />
        </b-tab>

        <b-tab title="Contatos">
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.contatos"
            />
            Contatos
          </template>
          <Contatos v-model="concedente.contatos" ref="contatos" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";
import Contatos from "./Form/Contatos.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos, Endereco, Contatos },
  data: () => ({
    validations: {
      dados_basicos: true,
      endereco: true,
      contatos: true,
    },
  }),
  computed: {
    ...mapState("concedentes", ["concedente"]),
  },
  methods: {
    ...mapActions("concedentes", ["ActionSave"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.concedente);
          this.$emit("saved", this.concedente.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.endereco =
        this.concedente.sem_endereco || this.$refs.endereco.isValid();

      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();

      return Object.values(this.validations).every(Boolean);
    },
  },
  async created() {},
};
</script>

<style>
.nav-pills .nav-item {
  margin-bottom: 0.5rem;
}
.nav-pills .nav-item:not(:last-child) {
  padding-right: 0;
}
</style>
